import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Dictionary } from 'src/app/store/models/common_types';

@Component({
  selector: 'app-range-filter',
  templateUrl: './range-filter.component.html',
  styleUrls: ['./range-filter.component.scss']
})
export class RangeFilterComponent {
  @Input() data: Dictionary<Date>;
  @Input() facetFilter ={} as any;
  @Input() loading: boolean;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() panel = {} as any;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  dateRange: Array<Date> = [];

  ngOnChanges(changes: SimpleChanges) {
    if(changes.facetFilter) {
      if(this.facetFilter.start_date && this.facetFilter.end_date) {
        this.dateRange[0] = this.facetFilter.start_date;
        this.dateRange[1] = this.facetFilter.end_date;
      }
    }
  }
  onRangeChange(dateRange: Array<Date>) {
    console.log(dateRange);
    let start_date = dateRange[0].toISOString().split('T')[0];
    let end_date = dateRange[1].toISOString().split('T')[0];
    let payload = {start_date, end_date };
    this.onChange.emit(payload);
  }
}
